import React from 'react';
import Icon from '../../../components/AppIcon';

const BudgetSummary = ({ originalBudget, totalCost, budgetStatus }) => {
  return (
    <div className="bg-gradient-to-r from-[#2E8B8B] to-[#F4A261] rounded-2xl shadow-lg p-6 text-white">
      <div className="flex items-center gap-3 mb-4">
        <Icon name="Wallet" size={28} />
        <h3 className="text-2xl font-bold">Budget Overview</h3>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4">
          <p className="text-sm opacity-90 mb-1">Original Budget</p>
          <p className="text-2xl font-bold">₱{originalBudget?.toLocaleString()}</p>
        </div>

        <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4">
          <p className="text-sm opacity-90 mb-1">Current Total</p>
          <p className="text-2xl font-bold">₱{totalCost?.toLocaleString()}</p>
        </div>

        <div className={`backdrop-blur-sm rounded-xl p-4 ${
          budgetStatus?.isOverBudget ? 'bg-red-500/20' : 'bg-white/10'
        }`}>
          <div className="flex items-center gap-2 mb-1">
            <p className="text-sm opacity-90">Remaining</p>
            {budgetStatus?.isOverBudget && (
              <Icon name="AlertTriangle" size={16} />
            )}
          </div>
          <p className={`text-2xl font-bold ${
            budgetStatus?.isOverBudget ? 'text-red-100' : ''
          }`}>
            ₱{Math.abs(budgetStatus?.remaining)?.toLocaleString()}
          </p>
          {budgetStatus?.isOverBudget && (
            <p className="text-xs mt-1 opacity-90">Over budget</p>
          )}
        </div>
      </div>

      {/* Progress Bar */}
      <div className="mt-6">
        <div className="flex items-center justify-between mb-2">
          <span className="text-sm opacity-90">Budget Usage</span>
          <span className="text-sm font-semibold">
            {budgetStatus?.percentage?.toFixed(1)}%
          </span>
        </div>
        <div className="w-full bg-white/20 rounded-full h-3 overflow-hidden">
          <div
            className={`h-full transition-all duration-500 ${
              budgetStatus?.isOverBudget 
                ? 'bg-red-400' 
                : budgetStatus?.percentage > 80 
                  ? 'bg-yellow-400' :'bg-green-400'
            }`}
            style={{ width: `${Math.min(budgetStatus?.percentage, 100)}%` }}
          />
        </div>
      </div>
    </div>
  );
};

export default BudgetSummary;